export default "__VITE_ASSET__d68cfb9e__"